import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';

import ArrowBack from 'components/common/components/ArrowBack';
import { formStyles } from 'consts/styles/Form';
import EditOrganization from './EditOrganization/EditOrganization';
import ExistingOrganizations from './ExistingOrganizations/ExistingOrganizations';
import AddOrganization from './NewOrganization/AddOrganization';

const Organization = () => {
  const formClasses = formStyles();

  const [
    parentOrganizationSelected,
    setParentOrganizationSelected,
  ] = React.useState(null);
  const [organizationToEdit, setOrganizationToEdit] = React.useState(null);
  const useString = () => {
    const language = useSelector(state => state.language);

    return language.adminZone;
  };

  const viewCasesStrings = {
    listHeader: useString().menuOptions.first_,
  };

  const arrowBackClick = () => {
    setOrganizationToEdit(null);
    setParentOrganizationSelected(null);
  };

  return (
    <Container component="main">
      {organizationToEdit || parentOrganizationSelected ? (
        <ArrowBack
          fromLeft={0}
          clickFunction={arrowBackClick}
          className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field__title`}
        />
      ) : (
        <Typography
          variant="h3"
          className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field__title`}
        >
          {viewCasesStrings.listHeader}
        </Typography>
      )}
      {organizationToEdit || parentOrganizationSelected ? (
        <div>
          {organizationToEdit && (
            <EditOrganization
              organization={organizationToEdit}
              arrowBackClick={arrowBackClick}
            />
          )}
          {parentOrganizationSelected && (
            <AddOrganization
              parentOrganizationSelected={parentOrganizationSelected}
              arrowBackClick={arrowBackClick}
            />
          )}
        </div>
      ) : (
        <div className={`${formClasses.Form}__overflow-component`}>
          <ExistingOrganizations
            onParentOrganizationSelect={setParentOrganizationSelected}
            onOrganizationToEditSelect={setOrganizationToEdit}
          />
        </div>
      )}
    </Container>
  );
};

export default Organization;
